import SettingsItem from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItem";
import SettingsItemText from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";
import usePageEditorStore from "@/components/PageEditor/store/usePageEditorStore";
import { useEditor, useNode } from "@craftjs/core";
import { Grid, MenuItem } from "@mui/material";

const Settings = () => {
    const regions = usePageEditorStore((state) => state.regions);
    const { id } = useNode();
    const { displayName, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
    }));

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                    />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <SettingsItem fullWidth propKey="region" type="select" label="Region">
                        <MenuItem value={"-1"}>ALL</MenuItem>
                        {regions
                            .filter((x) => x.active)
                            .map((region, index) => {
                                const key = region.slug;
                                const label = region.languages.find((y) => y.slug === `${key}-en`)?.regionLabel || key;

                                return (
                                    <MenuItem value={key} key={index}>
                                        {label}
                                    </MenuItem>
                                );
                            })}
                    </SettingsItem>
                </Grid>
            </SettingsSection>
        </>
    );
};

export default Settings;
